import {
  Breadcrumb,
  ErrorAlert,
  LinkBtn,
  PageHero,
  SearchToggle,
  SwatchIcon,
  useCanShow,
} from "@";
import MultiSearch from "../components/MultiSearch";
import { TableActions } from "../components/TableOptions";
import { useThemesPage } from "../hooks/index";
import { ThemeGallery } from "../components/theme-gallery";
import { cardZone } from "../../shared/cards";

const Page = () => {
  const {
    appliedSearch,
    totalItems,
    isLoading,
    error,
    refetch,
    search,
    updateSearch,
    handleSearchSubmit,
    handleSearchReset,
    handleDelete,
    handleTogglePublish,
  } = useThemesPage();

  const canViewThemes = useCanShow("viewThemes");
  const canEditThemes = useCanShow("editThemes");
  const canPublishThemes = useCanShow("publishThemes");
  const canSeeThemes = canViewThemes || canEditThemes || canPublishThemes;

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "الثيمات", link: "" }]} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الموقع / الثيمات"
          title="الثيمات"
          count={totalItems}
          icon={SwatchIcon}
          hideCount={isLoading}
        >
          {canEditThemes && <LinkBtn to="/website/themes/create" create />}
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={handleSearchSubmit}
          updateSearch={updateSearch}
          onReset={handleSearchReset}
        />

        {canSeeThemes && (
          <div className={cardZone}>
            <ThemeGallery
              search={appliedSearch}
              renderActions={(theme) => (
                <TableActions
                  row={theme}
                  deleteHandler={handleDelete}
                  TogglePublished={handleTogglePublish}
                />
              )}
            />
          </div>
        )}
      </main>
    </>
  );
};

export default Page;
